/* WL NeeDoh reserve bundle — product page logic (sections/wl-needoh-bundle.liquid).
   The basket is the single source of truth: Add / + / − change the real basket straight away, and the page
   re-reads the basket whenever it changes (here, in the slide-out basket, in another tab, or on coming back).
   Squishy changes use /cart/update and /cart/change, not /cart/add, so the "Added to basket" window stays shut
   while people build a bundle. All money is integer pence. The pure functions are tested in Node. */
(function () {
  // Bundle maths. Each NeeDoh needs its own minimum of qualifying (non-NeeDoh) squishies; the NeeDoh's own price is on
  // top and doesn't count. Same rule as the checkout rule (WL-Jadlam-ShipPriceND app).
  function computeBundle(input) {
    var needohTotal = input.needohUnitPrice * input.needohQty;
    var picked = (input.picks || []).reduce(function (sum, p) { return sum + p.price * p.qty; }, 0);
    var qualifyingTotal = picked + (input.cartQualifying || 0);
    var bundleMin = input.minTotal * Math.max(1, input.needohQty);
    var qualifyingTarget = bundleMin;
    var remaining = Math.max(0, qualifyingTarget - qualifyingTotal);
    var total = needohTotal + qualifyingTotal;
    return {
      needohTotal: needohTotal,
      qualifyingTotal: qualifyingTotal,
      qualifyingTarget: qualifyingTarget,
      remaining: remaining,
      total: total,
      bundleMin: bundleMin,
      progress: bundleMin > 0 ? Math.min(1, qualifyingTotal / bundleMin) : 1,
      unlocked: input.needohQty >= 1 && remaining === 0
    };
  }

  // Same rule as the Liquid: a NeeDoh is anything whose vendor is, or whose title contains, the excluded name.
  function isNeedoh(line, needohName) {
    if (!needohName) return false;
    var name = needohName.toLowerCase();
    return String(line.vendor || '').toLowerCase() === name || String(line.product_title || '').toLowerCase().indexOf(name) !== -1;
  }

  // What in the basket matters to the bundle: qualifying spend, this NeeDoh, any other NeeDoh, quantity per variant.
  // countOne: product ids that count once towards the bundle however many are in the basket (deal squishies).
  function summariseCart(cart, qualifyingIds, needohVariantId, needohName, countOne) {
    var out = { qualifying: 0, needohQty: 0, otherNeedohQty: 0, otherNeedohLines: [], qtyByVariant: {}, firstLineByVariant: {} };
    var counted = {};
    (cart.items || []).forEach(function (line) {
      out.qtyByVariant[line.variant_id] = (out.qtyByVariant[line.variant_id] || 0) + line.quantity;
      if (!out.firstLineByVariant[line.variant_id]) out.firstLineByVariant[line.variant_id] = line;
      if (line.variant_id === needohVariantId) out.needohQty += line.quantity;
      else if (isNeedoh(line, needohName)) { out.otherNeedohQty += line.quantity; out.otherNeedohLines.push(line); }
      else if (qualifyingIds[line.product_id]) {
        if (countOne && countOne[line.product_id]) {
          if (!counted[line.product_id]) { counted[line.product_id] = true; out.qualifying += line.final_line_price / line.quantity; }
        } else out.qualifying += line.final_line_price;
      }
    });
    return out;
  }

  // Squishy picks the shopper has made but the basket hasn't confirmed yet ({variantId: wanted qty}) as one /cart/update.js
  // body. A variant already in the basket is changed through its first line's key (other lines of it keep their qty).
  function pickUpdates(summary, wanted) {
    var updates = {};
    Object.keys(wanted).forEach(function (id) {
      var have = summary.qtyByVariant[id] || 0;
      if (wanted[id] === have) return;
      var line = summary.firstLineByVariant[id];
      if (line) updates[line.key] = Math.max(0, line.quantity + wanted[id] - have);
      else updates[id] = wanted[id];
    });
    return updates;
  }

  // The NeeDoh limit per order covers every NeeDoh product, counting the one being reserved.
  function needohLimit(summary, maxPerOrder) {
    var units = summary.otherNeedohQty + Math.max(1, summary.needohQty);
    return { units: units, ok: units <= maxPerOrder };
  }

  // Fixed bundle: it brings one NeeDoh with it, so every NeeDoh already in the basket (a NeeDoh on its own, or another
  // NeeDoh bundle, whose title names it) counts towards the limit.
  function fixedBundleLimit(cart, needohName, maxPerOrder) {
    var lines = (cart.items || []).filter(function (line) { return isNeedoh(line, needohName); });
    var units = lines.reduce(function (sum, line) { return sum + line.quantity; }, 0) + 1;
    return { lines: lines, units: units, ok: units <= maxPerOrder };
  }

  // Advent draw: the first entry needs entryPence of qualifying (non-NeeDoh) squishies in the order. Once unlocked, every
  // entryPence of the order's eligible spend (everything except NeeDoh and gift cards, squishies included) is an entry,
  // up to cap entries per order.
  function adventEntries(qualifyingPence, eligiblePence, entryPence, cap) {
    if (qualifyingPence < entryPence) {
      return { unlocked: false, entries: 0, capped: false, toNext: entryPence - qualifyingPence, progress: qualifyingPence / entryPence };
    }
    var raw = Math.floor(Math.max(eligiblePence, qualifyingPence) / entryPence);
    var entries = Math.min(cap, raw);
    var capped = raw >= cap;
    return {
      unlocked: true, entries: entries, capped: capped,
      toNext: capped ? 0 : entryPence - (eligiblePence - raw * entryPence),
      progress: capped ? 1 : (eligiblePence % entryPence) / entryPence
    };
  }

  // Everything in the basket that earns entries once unlocked: all lines except NeeDoh and gift cards.
  function eligibleSpend(cart, needohName) {
    return (cart.items || []).reduce(function (sum, line) {
      return line.gift_card || isNeedoh(line, needohName) ? sum : sum + line.final_line_price;
    }, 0);
  }

  // The NeeDoh's basket line on the build-your-own page: a pre-order is marked with its dispatch; an in-stock NeeDoh
  // ships straight away, so it carries nothing about dispatch. Random-colour NeeDoh say so either way.
  function needohLineProperties(cfg) {
    // _wl_bundle marks the NeeDoh as part of a bundle, so the site-wide NeeDoh lock (snippets/wl-needoh-lock) lets it in.
    var props = { _wl_bundle: 'Squishy Bundle' };
    if (!cfg.shipsNow) props['Pre-order'] = cfg.dispatchText;
    if (cfg.randomColour) props.Colour = 'Chosen at random';
    // Deal NeeDoh: the "sold as one set" agreement, with when, so it shows on the order.
    if (cfg.dealTerms && cfg.termsAgreedAt) props['Bundle terms'] = 'Agreed: sold as one set (' + cfg.termsAgreedAt + ')';
    return props;
  }

  // The lines a ready-made bundle adds: the bundle product, or (preview) the NeeDoh and its squishies, all tagged with
  // the bundle's name; pre-order lines also carry the dispatch.
  function fixedBundleItems(cfg) {
    var main = { _wl_bundle: cfg.bundleTitle };
    if (!cfg.shipsNow) main['Pre-order'] = cfg.dispatchText;
    if (cfg.randomColour) main.Colour = 'Chosen at random';
    var component = { _wl_bundle: cfg.bundleTitle };
    if (!cfg.shipsNow) component['Ships with'] = 'your NeeDoh pre-order';
    return cfg.items.map(function (it) {
      return { id: it.id, quantity: 1, properties: it.role === 'component' ? component : main };
    });
  }

  // Photo gallery swipe: a clear sideways swipe (40px+, more across than down) moves one photo, wrapping round;
  // anything else (a tap, a page scroll) stays put. Left = next.
  function swipeTarget(index, count, dx, dy) {
    if (count < 2 || Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return index;
    return dx < 0 ? (index + 1) % count : (index - 1 + count) % count;
  }

  // Next draw still to happen (by date, ignoring ones marked drawn), or null when all are done.
  function nextDraw(draws, todayIso) {
    for (var i = 0; i < draws.length; i++) {
      if (!draws[i].drawn && draws[i].date >= todayIso) return draws[i];
    }
    return null;
  }

  // Sold-out "next drop" alert. Same Klaviyo back-in-stock subscription the standard product page's button creates.
  var KLAVIYO_COMPANY = 'Wn7bvw';
  var KLAVIYO_REVISION = '2024-10-15';

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function backInStockPayload(email, variantId) {
    return {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: String(email).trim().toLowerCase() } } }
        },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      }
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { computeBundle: computeBundle, summariseCart: summariseCart, pickUpdates: pickUpdates, needohLimit: needohLimit, fixedBundleLimit: fixedBundleLimit,
      adventEntries: adventEntries, eligibleSpend: eligibleSpend, nextDraw: nextDraw, swipeTarget: swipeTarget,
      needohLineProperties: needohLineProperties, fixedBundleItems: fixedBundleItems,
      isValidEmail: isValidEmail, backInStockPayload: backInStockPayload };
    return;
  }

  function money(pence, currency) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(pence / 100);
  }

  var origFetch = window.fetch.bind(window);
  var SECTIONS = 'cart-icon-bubble,cart-drawer';
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function announceCartChange() {
    document.dispatchEvent(new CustomEvent('wl:cart-changed'));
  }

  // Watch fetch and XMLHttpRequest for basket changes made by the theme or apps, once for the whole page.
  function watchCart() {
    if (window.__wlCartWatch) return;
    window.__wlCartWatch = true;
    var prevFetch = window.fetch;
    window.fetch = function (input, init) {
      var res = prevFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && CART_CHANGE.test(url.split('#')[0])) res.then(announceCartChange, function () {});
      } catch (err) {}
      return res;
    };
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (String(method).toUpperCase() === 'POST' && CART_CHANGE.test(String(url).split('#')[0])) {
        this.addEventListener('loadend', announceCartChange);
      }
      return open.apply(this, arguments);
    };
  }

  // Refresh the header basket count and the slide-out basket from a Section Rendering API response.
  function applySections(sections) {
    if (!sections) return;
    [['cart-icon-bubble', 'cart-icon-bubble'], ['cart-drawer', 'CartDrawer']].forEach(function (pair) {
      var html = sections[pair[0]];
      var el = document.getElementById(pair[1]);
      if (!html || !el) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(pair[1]);
      if (fresh) el.innerHTML = fresh.innerHTML;
    });
    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) drawer.classList.toggle('is-empty', /is-empty/.test(sections['cart-drawer'].slice(0, 400)));
  }

  // After adding: open the basket. Preview copies (demo basket) stay on the page and say what would happen.
  function openBasket(stay) {
    if (window.wlDemoBasket) { stay(window.wlDemoBasket.message); return; }
    window.location.href = '/cart';
  }

  function postJSON(url, body) {
    return origFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong - please try again');
          return data;
        });
      });
  }

  function init(root) {
    var cfg = JSON.parse(root.querySelector('[data-bundle-config]').textContent);
    var qualifyingIds = {};
    cfg.qualifyingProductIds.forEach(function (id) { qualifyingIds[id] = true; });
    var countOne = {};
    (cfg.countOneProductIds || []).forEach(function (id) { countOne[id] = true; });

    var summary = summariseCart({ items: [] }, qualifyingIds, cfg.needoh.variantId, cfg.needohName, countOne);
    var busy = false;
    var lastTotal = null;
    // Picks not yet confirmed by the basket. Taps never wait on the network: each one squishes and updates the page at
    // once, and the picks are sent together as soon as the previous basket request has finished.
    var wanted = {};

    function qtyOf(id) { return id in wanted ? wanted[id] : summary.qtyByVariant[id] || 0; }
    function pending() { return Object.keys(pickUpdates(summary, wanted)).length > 0; }

    // Qualifying total including unconfirmed picks, priced from their cards.
    function qualifyingNow() {
      var total = summary.qualifying;
      root.querySelectorAll('[data-pick]').forEach(function (card) {
        var id = card.getAttribute('data-variant-id');
        if (!(id in wanted)) return;
        var have = summary.qtyByVariant[id] || 0, want = wanted[id];
        // A count-once card adds at most one copy's worth, whatever the quantity.
        if (card.hasAttribute('data-max')) { have = Math.min(have, 1); want = Math.min(want, 1); }
        total += (want - have) * Number(card.getAttribute('data-price'));
      });
      return Math.max(0, total);
    }

    function showError(msg) {
      root.querySelectorAll('[data-error]').forEach(function (el) { el.textContent = msg || ''; el.hidden = !msg; });
    }

    function render() {
      var reserved = summary.needohQty > 0;
      var limit = needohLimit(summary, cfg.maxPerOrder);
      var r = computeBundle({
        minTotal: cfg.minTotal,
        needohUnitPrice: cfg.needoh.price,
        needohQty: Math.max(1, summary.needohQty),
        cartQualifying: qualifyingNow()
      });
      var pct = Math.round(r.progress * 100) + '%';
      var squish = lastTotal !== null && lastTotal !== r.total;
      lastTotal = r.total;
      root.querySelectorAll('[data-progress-bar]').forEach(function (el) {
        el.style.width = pct;
        // Squish the tube whenever the bundle total changes (restart the animation by re-adding the class).
        if (squish) { el.classList.remove('is-squish'); void el.offsetWidth; el.classList.add('is-squish'); }
      });
      root.querySelectorAll('[data-total]').forEach(function (el) { el.textContent = money(r.qualifyingTotal, cfg.currency); });
      root.querySelectorAll('[data-bundle-min]').forEach(function (el) { el.textContent = money(r.bundleMin, cfg.currency); });
      root.querySelectorAll('[data-remaining]').forEach(function (el) { el.textContent = money(r.remaining, cfg.currency); });
      root.querySelectorAll('[data-when-locked]').forEach(function (el) { el.hidden = r.unlocked; });
      root.querySelectorAll('[data-when-unlocked]').forEach(function (el) { el.hidden = !r.unlocked || reserved; });
      root.querySelectorAll('[data-when-reserved]').forEach(function (el) { el.hidden = !reserved || !r.unlocked || !limit.ok; });

      var inCart = root.querySelector('[data-cart-qualifying]');
      if (inCart) {
        inCart.hidden = qualifyingNow() === 0;
        inCart.querySelector('[data-cart-qualifying-amount]').textContent = money(qualifyingNow(), cfg.currency);
      }

      // Too many NeeDohs in the basket: list what to take out, one click each.
      var limitBox = root.querySelector('[data-needoh-limit]');
      if (limitBox) {
        limitBox.hidden = limit.ok;
        var list = limitBox.querySelector('[data-needoh-limit-lines]');
        list.innerHTML = '';
        if (!limit.ok) {
          var fixes = summary.otherNeedohLines.map(function (l) { return { line: l, keep: 0, label: 'Remove' }; });
          var own = summary.firstLineByVariant[cfg.needoh.variantId];
          if (summary.needohQty > 1 && own) fixes.push({ line: own, keep: 1, label: 'Keep 1' });
          fixes.forEach(function (f) {
            var li = document.createElement('li');
            var name = document.createElement('span');
            name.textContent = f.line.product_title + (f.line.quantity > 1 ? ' × ' + f.line.quantity : '');
            var b = document.createElement('button');
            b.type = 'button';
            b.textContent = f.label;
            b.disabled = busy;
            b.setAttribute('data-fix-line', f.line.key);
            b.setAttribute('data-fix-qty', f.keep);
            li.appendChild(name);
            li.appendChild(b);
            list.appendChild(li);
          });
        }
      }

      var agreeBox = root.querySelector('[data-deal-agree]');
      var agreed = !cfg.dealTerms || !!(agreeBox && agreeBox.checked);
      root.querySelectorAll('[data-reserve]').forEach(function (btn) {
        var label = btn.querySelector('[data-reserve-label]');
        var ready = limit.ok && (reserved ? r.unlocked : r.unlocked && cfg.reserveOpen && agreed);
        btn.disabled = busy || pending() || !ready;
        btn.classList.toggle('is-ready', ready);
        if (label) {
          label.textContent = !limit.ok
            ? 'Only ' + cfg.maxPerOrder + ' NeeDoh per order'
            : reserved
            ? (r.unlocked ? (cfg.shipsNow ? 'In your basket – view basket' : 'Reserved – view basket') : 'Add ' + money(r.remaining, cfg.currency) + ' more to keep your NeeDoh')
            : cfg.reserveOpen && r.unlocked && !agreed ? 'Tick the box above to add the bundle'
            : cfg.reserveOpen ? (cfg.shipsNow ? 'Add bundle to basket – ' : 'Reserve bundle – ') + money(r.total, cfg.currency) : 'Reservations closed';
        }
      });

      root.querySelectorAll('[data-pick]').forEach(function (card) {
        var qty = qtyOf(card.getAttribute('data-variant-id'));
        card.classList.toggle('is-picked', qty > 0);
        card.querySelector('[data-pick-add]').hidden = qty > 0;
        card.querySelector('[data-pick-stepper]').hidden = qty === 0;
        card.querySelector('[data-pick-qty]').textContent = qty;
      });
    }

    function useCart(cart) {
      summary = summariseCart(cart, qualifyingIds, cfg.needoh.variantId, cfg.needohName, countOne);
      render();
    }

    function refresh() {
      return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(useCart)
        .catch(function () {});
    }

    // Every basket change ends with a fresh read of the basket, so the page never drifts from it.
    function change(request) {
      busy = true;
      showError('');
      render();
      return request
        .then(function (data) { applySections(data.sections); })
        .catch(function (err) { showError(err.message); })
        .then(function () { busy = false; return refresh(); });
    }

    function setVariantQty(variantId, qty) {
      wanted[variantId] = Math.max(0, qty);
      render();
      sendPicks();
    }

    // Send every unconfirmed pick in one request; picks made meanwhile go in the next one.
    function sendPicks() {
      if (busy) return;
      var sent = {};
      Object.keys(wanted).forEach(function (id) { sent[id] = wanted[id]; });
      var updates = pickUpdates(summary, sent);
      if (!Object.keys(updates).length) { wanted = {}; render(); return; }
      busy = true;
      showError('');
      postJSON('/cart/update.js', { updates: updates, sections: SECTIONS })
        .then(function (data) { applySections(data.sections); })
        .catch(function (err) { showError(err.message); })
        .then(refresh)
        .then(function () {
          // Confirmed (or refused - the basket is now the truth): forget the picks that were sent unless tapped again since.
          Object.keys(sent).forEach(function (id) { if (wanted[id] === sent[id]) delete wanted[id]; });
          busy = false;
          if (pending()) sendPicks(); else { wanted = {}; render(); }
        });
    }

    // Instant feedback on add, before the basket answers: the card squashes and bounces, and "+£x" floats up off the button.
    function squishCard(card, fromBtn) {
      card.classList.remove('is-squishing');
      void card.offsetWidth;
      card.classList.add('is-squishing');
      var pop = document.createElement('span');
      pop.className = 'wlnd__pop';
      pop.setAttribute('aria-hidden', 'true');
      pop.textContent = '+' + money(Number(card.getAttribute('data-price')), cfg.currency);
      if (fromBtn) pop.style.left = (fromBtn.offsetLeft + fromBtn.offsetWidth / 2) + 'px';
      card.appendChild(pop);
      setTimeout(function () { pop.remove(); }, 900);
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-pick]');
      if (card) {
        var id = card.getAttribute('data-variant-id');
        var qty = qtyOf(id);
        if (e.target.closest('[data-pick-add]') || e.target.closest('[data-pick-plus]')) {
          var max = Number(card.getAttribute('data-max') || 0);
          if (max && qty >= max) { showError('Only one of each squishy counts towards the deal.'); return; }
          squishCard(card, e.target.closest('button'));
          setVariantQty(id, qty + 1);
        } else if (e.target.closest('[data-pick-minus]')) setVariantQty(id, qty - 1);
        return;
      }
      var fix = e.target.closest('[data-fix-line]');
      if (fix && !busy) {
        change(postJSON('/cart/change.js', { id: fix.getAttribute('data-fix-line'), quantity: Number(fix.getAttribute('data-fix-qty')), sections: SECTIONS }));
        return;
      }
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) {
        var main = root.querySelector('.wlnd__main-image img');
        if (!main) return;
        main.src = thumb.getAttribute('data-src');
        main.removeAttribute('srcset');
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        return;
      }
      if (e.target.closest('[data-reserve]') && !busy && !pending()) reserve();
    });

    root.addEventListener('change', function (e) { if (e.target.matches('[data-deal-agree]')) render(); });

    function reserve() {
      if (cfg.soldOut || !needohLimit(summary, cfg.maxPerOrder).ok) return;
      if (summary.needohQty > 0) { window.location.href = '/cart'; return; }
      if (cfg.dealTerms) {
        var box = root.querySelector('[data-deal-agree]');
        if (!box || !box.checked) return;
        cfg.termsAgreedAt = new Date().toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
      }
      busy = true;
      showError('');
      render();
      postJSON('/cart/add.js', { items: [{ id: cfg.needoh.variantId, quantity: 1, properties: needohLineProperties(cfg) }] })
        // Pre-order only: order-level flag so the warehouse holds the whole parcel until the NeeDoh lands.
        .then(function () { return cfg.shipsNow ? null : postJSON('/cart/update.js', { attributes: { 'NeeDoh reserve': 'Hold whole order - ' + cfg.dispatchText } }); })
        .then(function () { openBasket(function (note) { busy = false; showError(note); refresh(); }); })
        .catch(function (err) { busy = false; showError(err.message); refresh(); });
    }

    // Basket changed somewhere else on the page (slide-out basket, quick-add, other apps): re-read it.
    document.addEventListener('wl:cart-changed', function () { if (!busy) refresh(); });
    // Changed in another tab, or back from the basket page (including the browser's back-forward cache).
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refresh(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

    // Sticky bar shows once the main CTA scrolls out of view.
    var sticky = root.querySelector('[data-sticky]');
    var anchor = root.querySelector('[data-sticky-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var below = entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && below);
      }).observe(anchor);
    }

    render();
    refresh();
  }

  // ---------- Fixed (ready-made) bundle page: sections/wl-needoh-fixed-bundle.liquid ----------
  function initFixed(root) {
    var cfg = JSON.parse(root.querySelector('[data-fixed-config]').textContent);
    var limit = { ok: true, lines: [] };
    var busy = false;

    function showError(msg) {
      root.querySelectorAll('[data-error]').forEach(function (el) { el.textContent = msg || ''; el.hidden = !msg; });
    }

    function render() {
      var box = root.querySelector('[data-needoh-limit]');
      if (box) {
        box.hidden = limit.ok;
        var list = box.querySelector('[data-needoh-limit-lines]');
        list.innerHTML = '';
        limit.lines.forEach(function (line) {
          var li = document.createElement('li');
          var name = document.createElement('span');
          name.textContent = line.product_title + (line.quantity > 1 ? ' × ' + line.quantity : '');
          var b = document.createElement('button');
          b.type = 'button';
          b.textContent = 'Remove';
          b.disabled = busy;
          b.setAttribute('data-fix-line', line.key);
          li.appendChild(name);
          li.appendChild(b);
          list.appendChild(li);
        });
      }
      root.querySelectorAll('[data-reserve]').forEach(function (btn) {
        var ready = cfg.reserveOpen && !cfg.soldOut && limit.ok && !busy;
        btn.disabled = !ready;
        btn.classList.toggle('is-ready', cfg.reserveOpen && limit.ok);
        var label = btn.querySelector('[data-reserve-label]');
        if (label && !limit.ok) label.textContent = 'Only ' + cfg.maxPerOrder + ' NeeDoh per order';
      });
    }

    function refresh() {
      return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { limit = fixedBundleLimit(cart, cfg.needohName, cfg.maxPerOrder); render(); })
        .catch(function () {});
    }

    function reserve() {
      busy = true;
      showError('');
      render();
      postJSON('/cart/add.js', { items: fixedBundleItems(cfg) })
        .then(function () { return cfg.shipsNow ? null : postJSON('/cart/update.js', { attributes: { 'NeeDoh reserve': 'Hold whole order - ' + cfg.dispatchText } }); })
        .then(function () { openBasket(function (note) { busy = false; showError(note); refresh(); }); })
        .catch(function (err) { busy = false; showError(err.message); refresh(); });
    }

    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) {
        var main = root.querySelector('.wlnd__main-image img');
        if (!main) return;
        main.src = thumb.getAttribute('data-src');
        main.removeAttribute('srcset');
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        return;
      }
      var fix = e.target.closest('[data-fix-line]');
      if (fix && !busy) {
        busy = true;
        render();
        postJSON('/cart/change.js', { id: fix.getAttribute('data-fix-line'), quantity: 0, sections: SECTIONS })
          .then(function (data) { applySections(data.sections); })
          .catch(function (err) { showError(err.message); })
          .then(function () { busy = false; refresh(); });
        return;
      }
      if (e.target.closest('[data-reserve]') && !busy && limit.ok) reserve();
    });

    document.addEventListener('wl:cart-changed', function () { if (!busy) refresh(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refresh(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

    var sticky = root.querySelector('[data-sticky]');
    var anchor = root.querySelector('[data-sticky-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(anchor);
    }

    render();
    refresh();
  }

  // Bundle carousels: arrows scroll most of a view; arrows grey out at the ends.
  function initCarousel(el) {
    var track = el.querySelector('[data-carousel-track]');
    var prev = el.querySelector('[data-carousel-prev]');
    var next = el.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.9 }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.9 }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // ---------- Advent Calendar giveaway page: sections/wl-advent-giveaway.liquid ----------
  function initAdvent(root) {
    var cfg = JSON.parse(root.querySelector('[data-advent-config]').textContent);
    var qualifyingIds = {};
    cfg.qualifyingProductIds.forEach(function (id) { qualifyingIds[id] = true; });
    var summary = summariseCart({ items: [] }, qualifyingIds, 0, cfg.needohName);
    var eligible = 0;
    var busy = false;
    var entryLabel = money(cfg.entryPence).replace('.00', '');

    // Next draw card: dates come from the schedule blocks; the page only needs updating to tick draws off.
    var next = nextDraw(cfg.draws, new Date().toISOString().slice(0, 10));
    var anyDrawn = cfg.draws.some(function (d) { return d.drawn; });
    var setText = function (sel, text) { var el = root.querySelector(sel); if (el) el.textContent = text; };
    if (next) {
      setText('[data-next-label]', anyDrawn ? 'Next draw' : 'First draw');
      setText('[data-next-date]', next.label);
      setText('[data-next-count]', next.calendars + ' calendars up for grabs');
    } else {
      setText('[data-next-label]', 'All draws done');
      setText('[data-next-date]', 'Thanks for entering!');
      setText('[data-next-count]', '');
    }

    function render() {
      var e = adventEntries(summary.qualifying, eligible, cfg.entryPence, cfg.entryCap);
      setText('[data-entries-count]', e.entries);
      setText('[data-entries-word]', e.entries === 1 ? 'entry' : 'entries');
      if (!e.unlocked) {
        setText('[data-entries-headline]', 'Add ' + money(e.toNext) + ' of squishies to unlock your first entry');
        setText('[data-entries-note]', money(summary.qualifying) + ' of qualifying squishies in your basket. Once you have ' + entryLabel +
          ' of squishies, every ' + entryLabel + ' of anything else in the order earns another entry.');
      } else if (e.capped) {
        setText('[data-entries-headline]', "Maximum " + cfg.entryCap + " entries for this order – you're all set!");
        setText('[data-entries-note]', money(eligible) + ' in your basket counts towards entries (everything except NeeDoh and gift cards).');
      } else {
        setText('[data-entries-headline]', "You're in! Add " + money(e.toNext) + ' of anything for entry number ' + (e.entries + 1));
        setText('[data-entries-note]', money(eligible) + ' in your basket counts – LEGO, RC, Scalextric, the lot (not NeeDoh or gift cards). Up to ' +
          cfg.entryCap + ' entries per order.');
      }
      var bar = root.querySelector('[data-entries-bar]');
      if (bar) bar.style.width = Math.round((e.unlocked && e.progress === 0 ? 1 : e.progress) * 100) + '%';
      root.querySelector('.wlad__entries').classList.toggle('is-in', e.entries > 0);
      root.querySelectorAll('[data-pick]').forEach(function (card) {
        var qty = summary.qtyByVariant[card.getAttribute('data-variant-id')] || 0;
        card.classList.toggle('is-picked', qty > 0);
        card.querySelector('[data-pick-add]').hidden = qty > 0;
        card.querySelector('[data-pick-stepper]').hidden = qty === 0;
        card.querySelector('[data-pick-qty]').textContent = qty;
        card.querySelectorAll('button').forEach(function (b) { b.disabled = busy; });
      });
    }

    function refresh() {
      return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { summary = summariseCart(cart, qualifyingIds, 0, cfg.needohName); eligible = eligibleSpend(cart, cfg.needohName); render(); })
        .catch(function () {});
    }

    function setQty(variantId, qty) {
      busy = true;
      render();
      var line = summary.firstLineByVariant[variantId];
      var req = line
        ? postJSON('/cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity + qty - summary.qtyByVariant[variantId]), sections: SECTIONS })
        : postJSON('/cart/update.js', { updates: (function () { var u = {}; u[variantId] = qty; return u; })(), sections: SECTIONS });
      req.then(function (data) { applySections(data.sections); })
        .catch(function (err) { var el = root.querySelector('[data-error]'); if (el) { el.textContent = err.message; el.hidden = false; } })
        .then(function () { busy = false; refresh(); });
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-pick]');
      if (!card || busy) return;
      var id = card.getAttribute('data-variant-id');
      var qty = summary.qtyByVariant[id] || 0;
      if (e.target.closest('[data-pick-add]') || e.target.closest('[data-pick-plus]')) {
        card.classList.remove('is-squishing'); void card.offsetWidth; card.classList.add('is-squishing');
        setQty(id, qty + 1);
      } else if (e.target.closest('[data-pick-minus]')) setQty(id, qty - 1);
    });
    document.addEventListener('wl:cart-changed', function () { if (!busy) refresh(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refresh(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    render();
    refresh();
  }

  function initDropAlert(root) {
    var form = root.querySelector('[data-drop-form]');
    var input = form.querySelector('input[type="email"]');
    var button = root.querySelector('[data-drop-submit]');
    var error = root.querySelector('[data-drop-error]');
    var done = root.querySelector('[data-drop-done]');
    function fail(message) { error.textContent = message; error.hidden = false; button.disabled = false; button.textContent = 'Alert me'; }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      error.hidden = true;
      if (!isValidEmail(input.value)) { fail('Please enter a valid email address.'); input.focus(); return; }
      button.disabled = true;
      button.textContent = 'Adding you…';
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(backInStockPayload(input.value, root.getAttribute('data-variant-id')))
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
        form.hidden = true;
        done.hidden = false;
      }).catch(function () {
        fail("Sorry, that didn't go through. Please try again.");
      });
    });
  }

  if (document.querySelector('[data-wl-needoh-bundle],[data-wl-needoh-fixed],[data-wl-advent]')) watchCart();
  // Swipe the big photo on a phone to move through the thumbnails (the thumbnails' own click handler swaps the photo).
  function initGallery(root) {
    var main = root.querySelector('.wlnd__main-image');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    if (!main || thumbs.length < 2) return;
    var x0 = null, y0 = 0;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var current = Math.max(0, thumbs.findIndex(function (b) { return b.classList.contains('is-active'); }));
      var next = swipeTarget(current, thumbs.length, t.clientX - x0, t.clientY - y0);
      x0 = null;
      if (next === current) return;
      thumbs[next].click();
      var strip = thumbs[next].parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: thumbs[next].offsetLeft - strip.offsetLeft - 8, behavior: 'smooth' });
    }, { passive: true });
  }

  document.querySelectorAll('[data-wl-needoh-bundle], [data-wl-needoh-fixed]').forEach(initGallery);
  document.querySelectorAll('[data-wl-needoh-bundle]').forEach(init);
  document.querySelectorAll('[data-wl-advent]').forEach(initAdvent);
  document.querySelectorAll('[data-wl-needoh-fixed]').forEach(initFixed);
  document.querySelectorAll('[data-drop-alert]').forEach(initDropAlert);
  document.querySelectorAll('[data-carousel]').forEach(initCarousel);

  // Hub: bundle theme filter chips (cards carry data-theme = the bundle theme name, handleized, without "Bundle").
  document.querySelectorAll('[data-hub-filters]').forEach(function (bar) {
    var grid = bar.parentNode.querySelector('[data-hub-bundles]');
    if (!grid) return;
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;
      var f = btn.getAttribute('data-filter');
      bar.querySelectorAll('[data-filter]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      grid.querySelectorAll('[data-theme]').forEach(function (card) { card.hidden = f !== 'all' && card.getAttribute('data-theme') !== f; });
    });
  });
})();
